export const NYLAS_GRANTS_QUERY_KEY = ["NYLAS_GRANTS"] as const;
export const CALENDAR_GRANTS_QUERY_KEY = ["NYLAS_GRANTS", "calendar"] as const;
export const MAIL_GRANTS_QUERY_KEY = ["NYLAS_GRANTS", "mail"] as const;
export const NYLAS_SYNC_SETTINGS_QUERY_KEY = ["NYLAS_SYNC_SETTINGS"] as const;
export const NYLAS_GRANT_CALENDARS_QUERY_KEY = [
  "NYLAS_GRANT_CALENDARS"
] as const;
export const nylasGrantCalendarsQueryKey = (grantId: number) =>
  [...NYLAS_GRANT_CALENDARS_QUERY_KEY, grantId] as const;
export const AVAILABLE_MAIL_GRANTS_QUERY_KEY = [
  "NYLAS_GRANTS",
  "available"
] as const;
